export default {
  text: '{0} would like to be allowed to send you news emails.',
  readAgreementButton: 'Read conditions',
  dontYouWantNewslettersFrom: 'Do you want to receive news emails from {0}?',
  action: {
    yes: 'Yes please',
    no: 'No'
  }
}